<template>
  <div class="Section">
    <transition name="fade" mode="out-in">
      <confirm
        v-if="confirmOpen"
        :title="'Are you sure you want to delete this section?'"
        :content="'This action is irreversible!'"
        @cancel="closeConfirm"
        @confirm="remove"
      />
    </transition>
    <div class="Section__header" @click="toggle">
      <div class="Section__header-text">
        <div class="Section__title">{{ section.name }}</div>
        <div class="Section__description">{{ section.description }}</div>
      </div>
      <div class="Section__icons" @click.prevent>
        <i class="icon icon-pencil icon-primary pointer" @click.stop="edit" />
        <i
          class="icon icon-trash-empty icon-danger pointer"
          @click.stop="openConfirm"
        />
      </div>
      <span
        :class="{ 'open-caret': toggleOpen }"
        class="Section__caret"
        @click="toggle"
      />
    </div>
    <draggable
      v-model="sectionElements"
      :class="{ open: toggleOpen }"
      :options="{ draggable: '.SectionElement' }"
      class="Section__content"
    >
      <section-element
        v-for="(element, index) in sectionElements"
        :element="element"
        :key="index + element.name"
        :elementindex="index"
        :sectionindex="sectionindex"
      />
      <div slot="footer" class="Section__content-add">
        <button class="button button-primary" @click="newElement">
          <i class="icon icon-plus" />
          Add element
        </button>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import SectionElement from './SectionElement';
import Confirm from '@/components/common/navigation/Confirm';

export default {
  name: 'SectionItem',
  components: {
    SectionElement,
    draggable,
    Confirm,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionindex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      toggleOpen: false,
      confirmOpen: false,
    };
  },

  computed: {
    elements() {
      if (this.section) {
        return this.section.elements;
      }
      return [];
    },
    sectionElements: {
      get() {
        return this.elements;
      },
      set(value) {
        this.$store.commit('updateSectionElements', {
          index: this.sectionindex,
          value: value,
        });
      },
    },
  },
  watch: {
    section(oldSection, newSection) {
      if (oldSection.name !== newSection.name) {
        this.toggleOpen = false;
      }
    },
  },
  methods: {
    openConfirm() {
      this.confirmOpen = true;
    },
    closeConfirm() {
      this.confirmOpen = false;
    },
    remove() {
      this.closeConfirm();
      this.$store.dispatch('removeSection', { section: this.sectionindex });
    },
    edit() {
      this.$router.push({
        name: 'editSection',
        params: { sectionIndex: this.sectionindex },
      });
    },
    toggle() {
      this.toggleOpen = !this.toggleOpen;
    },
    newElement() {
      this.$router.push({
        name: 'newElement',
        params: { sectionIndex: this.sectionindex },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/components/more-tab/sections/section/SectionItem.scss';
</style>
